import { render, staticRenderFns } from "./MCMSQuestion.vue?vue&type=template&id=63843cec&"
import script from "./MCMSQuestion.vue?vue&type=script&lang=js&"
export * from "./MCMSQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MCMSQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports